import React from "react"
import PropTypes from "prop-types"
import { Image, Text, Flex, Box } from "rebass"

const RelatedThumb = ({ data: { featured, title, excerpt, url } }) => (
  <Box
    as="a"
    href={url}
    target="_blank"
    rel="noreferrer noopener"
    sx={{
      borderTop: "1px solid black",
      borderBottom: "1px solid black",
      py: 3,
      my: 4,
      textDecoration: "none",
      transition: "all .3s ease",

      "&:hover": {
        opacity: 0.8,
      },

      p: {
        lineHeight: 1.2,
      },
    }}
  >
    <Flex sx={{ flexDirection: ["column", "row"] }}>
      <Image
        src={featured}
        alt={title}
        sx={{
          minWidth: "112px",
          maxWidth: "112px",
          width: "112px",
          height: "auto",
          p: 2,
          alignSelf: ["center", "flex-start"],
        }}
      />
      <Flex sx={{ flexDirection: "column", textAlign: ["center", "left"] }}>
        <Text as="h4" sx={{ color: "black", py: 2, fontSize: [3] }}>
          {title}
        </Text>
        <Text as="p" sx={{ fontSize: [2] }}>
          {excerpt}
        </Text>
      </Flex>
    </Flex>
  </Box>
)

RelatedThumb.propTypes = {
  data: PropTypes.shape({
    featured: PropTypes.string,
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
}

export default RelatedThumb
